/**
 * ChartCarousel
 *
 * @namespace APP
 * @name APP.ChartCarousel
 */
APP.ChartCarousel = (/** @lends APP.ChartCarousel */function () {
	'use strict';

	var exports,
		$body;

	/**
	 * Initialize ChartCarousel
	 *
	 * @inner
	 * @public
	 * @memberof APP.ChartCarousel
	 * @returns {void}
	 */
	function init() {
		$body = APP.Performance.getCachedDOM().$body;

		$body.find('[data-chart-slick]:not([data-carousel-initialized])')
			.attr('data-carousel-initialized', true)
			.slick({
			dots: false,
			speed: 300,
			slidesToShow: 3,
			centerMode: false,
			centerPadding: 0,
			infinite: false,
			slidesToScroll: 1,
			prevArrow: '<a data-role="none" role="button" class="carousel__arrow carousel__arrow--prev" tabindex="0"><i class="icon-wrapper"><svg viewBox="0 0 256 256"><use xlink:href="#icon-arrow-left"></use></svg></i></a>',
			nextArrow: '<a data-role="none" role="button" class="carousel__arrow carousel__arrow--next" tabindex="0"><i class="icon-wrapper"><svg viewBox="0 0 256 256"><use xlink:href="#icon-arrow-right"></use></svg></i></a>',
			responsive: [
				{
					breakpoint: 4000,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 820,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 680,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

		$body.find('[data-migration-carousel]')
			.slick({
			dots: false,
			speed: 300,
			slidesToShow: 4,
			/*centerMode: true,
			centerPadding: 0,*/
			infinite: true,
			slidesToScroll: 1,
			prevArrow: '<a data-role="none" role="button" class="carousel__arrow carousel__arrow--prev" tabindex="0"><i class="icon-wrapper"><svg viewBox="0 0 256 256"><use xlink:href="#icon-arrow-left"></use></svg></i></a>',
			nextArrow: '<a data-role="none" role="button" class="carousel__arrow carousel__arrow--next" tabindex="0"><i class="icon-wrapper"><svg viewBox="0 0 256 256"><use xlink:href="#icon-arrow-right"></use></svg></i></a>',
			responsive: [
				{
					breakpoint: 4000,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 820,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 680,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

		$body.find('[data-promo-slick]:not([data-carousel-initialized])')
			.attr('data-carousel-initialized', true)
			.slick({
			dots: false,
			speed: 300,
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: false,
			slidesToShow: 1,
			infinite: true,
			slidesToScroll: 1
		});

	}

	exports = {
		init: init
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
